'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var childrenOfType = {};

exports.__exports = childrenOfType;
